<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'

import {
  ASSET_MUTATION_UPDATE,
  GET_MUTATION_ASSET,
} from '@/services/api/setting/personalization/uiAsset'
/**
 * Starter component
 */
export default {
  page: {
    title: 'Manajemen Whitelabel',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  mixins: [Helper],
  apollo: {
    uiAsset: {
      query: GET_MUTATION_ASSET,
      manual: true,
      fetchPolicy: 'no-cache',
      result({ data, loading }) {
        if (!loading) {
          this.initData(data.uiAssets.uiAssets)
          this.switchPopup = data.uiAssets.uiAssets.find(
            (o) => o.assetType === 'banner' && o.module === 'popup'
          ).isActive
          this.visiblePopup = data.uiAssets.uiAssets.find(
            (o) => o.assetType === 'banner' && o.module === 'popup'
          ).isActive
          this.switchSidebar = data.uiAssets.uiAssets.find(
            (o) => o.assetType === 'banner' && o.module === 'sidebarMaximize'
          ).isActive
          this.visibleSidebar = data.uiAssets.uiAssets.find(
            (o) => o.assetType === 'banner' && o.module === 'sidebarMaximize'
          ).isActive
          this.switchEmail = data.uiAssets.uiAssets.find(
            (o) => o.assetType === 'banner' && o.module === 'email'
          ).isActive
          this.visibleEmail = data.uiAssets.uiAssets.find(
            (o) => o.assetType === 'banner' && o.module === 'email'
          ).isActive
        }
      },
    },
  },
  data() {
    return {
      companyId: this.getCompanyId(),
      imgPreview: require(`@/assets/images/default-image-user.png`),
      imgLogin: require(`@/assets/images/default-image-user.png`),
      nameLogin: null,
      ctaLink: null,
      imgPopup: require(`@/assets/images/default-image-user.png`),
      namePopup: null,
      switchPopup: false,
      visiblePopup: false,
      imgSidebarMax: require(`@/assets/images/default-image-user.png`),
      nameSidebarMax: null,
      imgSidebarMin: require(`@/assets/images/default-image-user.png`),
      nameSidebarMin: null,
      switchSidebar: false,
      visibleSidebar: false,
      imgHomepage: require(`@/assets/images/default-image-user.png`),
      nameHomepage: null,
      imgEmail: require(`@/assets/images/default-image-user.png`),
      nameEmail: null,
      switchEmail: false,
      visibleEmail: false,
      carouselData: [
        {
          key: 'exLogin',
          items: [
            {
              id: 1,
              image: require(`@/assets/images/example/whitelabel/banner/login/1.png`),
              caption: 'Halaman Login',
            },
          ],
        },
        {
          key: 'exPopup',
          items: [
            {
              id: 1,
              image: require(`@/assets/images/example/whitelabel/banner/popup/1.png`),
              caption: 'Halaman Beranda Web',
            },
          ],
        },
        {
          key: 'exSidebarMax',
          items: [
            {
              id: 1,
              image: require(`@/assets/images/example/whitelabel/banner/sidebar/1.png`),
              caption: 'Sidebar Maksimal',
            },
          ],
        },
        {
          key: 'exSidebarMin',
          items: [
            {
              id: 1,
              image: require(`@/assets/images/example/whitelabel/banner/sidebar/2.png`),
              caption: 'Sidebar Minimal',
            },
          ],
        },
        {
          key: 'exHomepage',
          items: [
            {
              id: 1,
              image: require(`@/assets/images/example/whitelabel/banner/homepage-mobile/1.png`),
              caption: 'Beranda Mobile',
            },
          ],
        },
        {
          key: 'exEmail',
          items: [
            {
              id: 1,
              image: require(`@/assets/images/example/whitelabel/banner/email/1.png`),
              caption: 'Footer Email',
            },
          ],
        },
      ],
      carouselItems: null,
    }
  },

  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    title() {
      return this.$t('setting.list.managementAsset.banner.title')
    },
    items() {
      return [
        {
          text: this.$t('setting.homePage.pengaturan'),
          to: { name: 'Setting' },
        },
        {
          text: this.$t('setting.homePage.whitelabel'),
          to: { name: 'Management Whitelabel' },
        },
        {
          text: this.$t('setting.list.managementAsset.banner.title'),
          active: true,
        },
      ]
    },
  },

  methods: {
    onExample(id_logo) {
      const ex_logo = id_logo
      const carousel_data = this.$data.carouselData
      for (const element of carousel_data) {
        if (element.key == ex_logo) {
          this.carouselItems = element.items
        }
      }
      this.$bvModal.show('modalExample')
    },
    previewImage(id_logo) {
      const ex_logo = id_logo
      switch (ex_logo) {
        case 'exLogin':
          this.imgPreview = this.imgLogin
          break
        case 'exPopup':
          this.imgPreview = this.imgPopup
          break
        case 'exSidebarMax':
          this.imgPreview = this.imgSidebarMax
          break
        case 'exSidebarMin':
          this.imgPreview = this.imgSidebarMin
          break
        case 'exHomepage':
          this.imgPreview = this.imgHomepage
          break
        case 'exEmail':
          this.imgPreview = this.imgEmail
          break
        default:
          this.imagePreview = this.imgPreview
          break
      }
      this.$bvModal.show('modalPreviewImage')
    },
    closeExample() {
      this.carouselItems = null
      this.$bvModal.hide('modalExample')
      this.$bvModal.hide('modalPreviewImage')
    },
    handleFileSelected(e) {
      const indexField = e.target.id
      const file = e.target.files[0]
      const extension_file = ['image/jpg', 'image/jpeg', 'image/png']

      if (file) {
        if (file.size >= 2048000) {
          e.target.value = null
          return this.$mcToast.error(this.$t('global.errorLimitImage'))
        }
        if (!extension_file.includes(file.type)) {
          e.target.value = null
          return this.$mcToast.error(this.$t('global.errorFormatImage'))
        }
        this.toSave(indexField, file)
      }
    },
    async toSave(indexField, file) {
      let assetType = null
      let module = null
      let valChecked = true
      const valueIndexing = [
        {
          key: 'bannerLogin',
          assetType: 'banner',
          module: 'login',
          valChecked: true,
        },
        {
          key: 'bannerPopup',
          assetType: 'banner',
          module: 'popup',
          valChecked: this.switchPopup,
        },
        {
          key: 'bannerSidebarMax',
          assetType: 'banner',
          module: 'sidebarMaximize',
          valChecked: this.switchSidebar,
        },
        {
          key: 'bannerSidebarMin',
          assetType: 'banner',
          module: 'sidebarMinimize',
          valChecked: this.switchSidebar,
        },
        {
          key: 'bannerHomepage',
          assetType: 'banner',
          module: 'mobile',
          valChecked: true,
        },
        {
          key: 'bannerEmail',
          assetType: 'banner',
          module: 'email',
          valChecked: this.switchEmail,
        },
      ]
      for (const element of valueIndexing) {
        if (element.key == indexField) {
          assetType = element.assetType
          module = element.module
          valChecked = element.valChecked
        }
      }

      const input = {
        assetType: assetType,
        module: module,
        data: {
          value: null,
          isActive: valChecked,
          isPhoto: true,
          photoExt: null,
        },
      }

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => resolve(reader.result)
          reader.onerror = (error) => reject(error)
        })

      input.data.value = (await toBase64(file)).split(',')[1]
      input.data.photoExt = file.type.split('/')[1]

      this.$apollo
        .mutate({
          mutation: ASSET_MUTATION_UPDATE,
          variables: {
            input: input,
          },
        })
        .then((response) => {
          if (response.data.updateUIAssets.message != 'Successful') {
            return this.$mcToast.error(this.$t('global.alert.text.failSave'))
          }

          if (indexField == 'bannerLogin') {
            this.imgLogin = response.data.updateUIAssets.updateUIAssets[0].value
            this.nameLogin = response.data.updateUIAssets.updateUIAssets[0].fileName
          }

          if (indexField == 'bannerPopup') {
            this.imgPopup = response.data.updateUIAssets.updateUIAssets[0].value
            this.namePopup = response.data.updateUIAssets.updateUIAssets[0].fileName
          }

          if (indexField == 'bannerSidebarMax') {
            this.imgSidebarMax = response.data.updateUIAssets.updateUIAssets[0].value
            this.nameSidebarMax = response.data.updateUIAssets.updateUIAssets[0].fileName
          }

          if (indexField == 'bannerSidebarMin') {
            this.imgSidebarMin = response.data.updateUIAssets.updateUIAssets[0].value
            this.nameSidebarMin = response.data.updateUIAssets.updateUIAssets[0].fileName
          }

          if (indexField == 'bannerHomepage') {
            this.imgHomepage = response.data.updateUIAssets.updateUIAssets[0].value
            this.nameHomepage = response.data.updateUIAssets.updateUIAssets[0].fileName
          }

          if (indexField == 'bannerEmail') {
            this.imgEmail = response.data.updateUIAssets.updateUIAssets[0].value
            this.nameEmail = response.data.updateUIAssets.updateUIAssets[0].fileName
          }
          this.$mcToast.success(this.$t('global.alert.text.saved'))
        })
    },
    changeCtaLink() {
      if (this.ctaLink !== null) {
        const input = {
          assetType: 'bannerDirect',
          module: 'general',
          data: {
            value: this.ctaLink,
            isActive: true,
            isPhoto: false,
            photoExt: null,
          },
        }

        this.$apollo
          .mutate({
            mutation: ASSET_MUTATION_UPDATE,
            variables: {
              input: input,
            },
          })
          .then((response) => {
            if (response.data.updateUIAssets.message != 'Successful') {
              return this.$mcToast.error(this.$t('global.alert.text.failSave'))
            }
            this.tabTitle = response.data.updateUIAssets.updateUIAssets[0].value
            return this.$mcToast.success(this.$t('global.alert.text.saved'))
          })
      }
    },
    onSwitchPopup() {
      if (this.imgPopup.includes('data:image')) {
        this.imgPopup = null
      }
      const input = {
        assetType: 'banner',
        module: 'popup',
        data: {
          value: this.imgPopup,
          isActive: this.switchPopup,
          isPhoto: false,
          photoExt: null,
        },
      }

      this.$apollo
        .mutate({
          mutation: ASSET_MUTATION_UPDATE,
          variables: {
            input: input,
          },
        })
        .then((response) => {
          if (response.data.updateUIAssets.message != 'Successful') {
            return this.$mcToast.error(this.$t('global.alert.text.failSave'))
          }
          return this.$mcToast.success(this.$t('global.alert.text.saved'))
        })
    },
    onSwitchSidebar() {
      if (this.imgSidebarMax.includes('data:image')) {
        this.imgSidebarMax = null
      }
      if (this.imgSidebarMin.includes('data:image')) {
        this.imgSidebarMin = null
      }
      const input = [
        {
          assetType: 'banner',
          module: 'sidebarMaximize',
          data: {
            value: this.imgSidebarMax,
            isActive: this.switchSidebar,
            isPhoto: false,
            photoExt: null,
          },
        },
        {
          assetType: 'banner',
          module: 'sidebarMinimize',
          data: {
            value: this.imgSidebarMin,
            isActive: this.switchSidebar,
            isPhoto: false,
            photoExt: null,
          },
        },
      ]

      this.$apollo
        .mutate({
          mutation: ASSET_MUTATION_UPDATE,
          variables: {
            input: input,
          },
        })
        .then((response) => {
          if (response.data.updateUIAssets.message != 'Successful') {
            return this.$mcToast.error(this.$t('global.alert.text.failSave'))
          }
          return this.$mcToast.success(this.$t('global.alert.text.saved'))
        })
    },
    onSwitchEmail() {
      if (this.imgEmail.includes('data:image')) {
        this.imgEmail = null
      }
      const input = [
        {
          assetType: 'banner',
          module: 'email',
          data: {
            value: this.imgEmail,
            isActive: this.switchEmail,
            isPhoto: false,
            photoExt: null,
          },
        },
      ]

      this.$apollo
        .mutate({
          mutation: ASSET_MUTATION_UPDATE,
          variables: {
            input: input,
          },
        })
        .then((response) => {
          if (response.data.updateUIAssets.message != 'Successful') {
            return this.$mcToast.error(this.$t('global.alert.text.failSave'))
          }
          return this.$mcToast.success(this.$t('global.alert.text.saved'))
        })
    },
    initData(data) {
      const detail = data
      for (const element of detail) {
        if (element.assetType == 'banner' && element.module == 'login' && !element.isDefault) {
          this.imgLogin = element.value
          this.nameLogin = element.fileName
        } else if (
          element.assetType == 'banner' &&
          element.module == 'popup' &&
          !element.isDefault
        ) {
          this.imgPopup = element.value ? element.value : this.imgPreview
          this.namePopup = element.fileName
        } else if (
          element.assetType == 'banner' &&
          element.module == 'sidebarMaximize' &&
          !element.isDefault
        ) {
          this.imgSidebarMax = element.value ? element.value : this.imgPreview
          this.nameSidebarMax = element.fileName
        } else if (
          element.assetType == 'banner' &&
          element.module == 'sidebarMinimize' &&
          !element.isDefault
        ) {
          this.imgSidebarMin = element.value ? element.value : this.imgPreview
          this.nameSidebarMin = element.fileName
        } else if (
          element.assetType == 'banner' &&
          element.module == 'mobile' &&
          !element.isDefault
        ) {
          this.imgHomepage = element.value ? element.value : this.imgPreview
          this.nameHomepage = element.fileName
        } else if (
          element.assetType == 'banner' &&
          element.module == 'email' &&
          !element.isDefault
        ) {
          this.imgEmail = element.value ? element.value : this.imgPreview
          this.nameEmail = element.fileName
        }
      }

      this.ctaLink = detail.find(
        (o) => o.assetType === 'bannerDirect' && o.module === 'general'
      ).value
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />
      <p class="mb-4">{{ $t('setting.list.managementAsset.banner.subtitle') }}</p>
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button
            @click="$router.push({ name: 'Management Whitelabel' })"
            variant="outline-primary"
            class="ms-3"
          >
            <i class="mc-fa icon-outline_arrow-left"></i>
            {{ $t('global.back') }}
          </b-button>
        </div>
      </div>
    </div>

    <div class="mc-form">
      <h4 class="card-title">{{ $t('setting.list.managementAsset.banner.login') }}</h4>
      <b-card>
        <b-row>
          <b-col sm="12" md="12">
            <b-row>
              <b-col md="3">
                <div
                  class="d-flex justify-content-right mb-2 img-pointer"
                  @click="previewImage('exLogin')"
                >
                  <img
                    :src="imgLogin"
                    alt
                    class="avatar-lg rounded-circle img-thumbnail"
                    style="object-fit: cover"
                  />
                </div>
              </b-col>
              <b-col md="12">
                <h5 class="font-size-12 teal-400 mb-1">
                  {{ nameLogin }}
                </h5>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" md="6">
            <b-row>
              <b-col md="12">
                <div class="mc-input-info">
                  <b-form-group
                    id="fleet_brand_type_label"
                    :label="$t('global.uploadImage')"
                    label-for="fleet_brand_type"
                  >
                    <input
                      class="form-control inputf-ile"
                      type="file"
                      ref="file"
                      id="bannerLogin"
                      accept="image/*"
                      v-on:change="handleFileSelected"
                    />
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="12" class="mt-3">
                <a href="javascript:void(0)" @click="onExample('exLogin')">
                  <strong class="font-weight-bold text-primary">
                    {{ $t('global.exampleAsset') }}
                  </strong>
                </a>
              </b-col></b-row
            >
          </b-col>
        </b-row>
      </b-card>
    </div>

    <div class="mc-form mb-3">
      <div class="form-check-right form-switch">
        <input
          class="form-check-input"
          type="checkbox"
          v-b-toggle.accordion-popup
          v-model="switchPopup"
          v-on:change="onSwitchPopup"
        />
      </div>
      <span class="card-title p-2">{{ $t('setting.list.managementAsset.banner.popup') }}</span>
      <b-collapse
        id="accordion-popup"
        accordion="accordionPopup"
        role="tabpanel"
        v-model="visiblePopup"
      >
        <b-card>
          <b-row>
            <b-col sm="12" md="12">
              <b-row>
                <b-col md="3">
                  <div
                    class="d-flex justify-content-right mb-2 img-pointer"
                    @click="previewImage('exPopup')"
                  >
                    <img
                      :src="imgPopup"
                      alt
                      class="avatar-lg rounded-circle img-thumbnail"
                      style="object-fit: cover"
                    />
                  </div>
                </b-col>
                <b-col md="12">
                  <h5 class="font-size-12 teal-400 mb-1">
                    {{ namePopup }}
                  </h5>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="12" md="6">
              <b-row>
                <b-col md="12">
                  <div class="mc-input-info">
                    <b-form-group
                      id="fleet_brand_type_label"
                      :label="$t('global.uploadImage')"
                      label-for="fleet_brand_type"
                    >
                      <input
                        class="form-control inputf-ile"
                        type="file"
                        ref="file"
                        id="bannerPopup"
                        accept="image/*"
                        v-on:change="handleFileSelected"
                      />
                    </b-form-group>
                  </div>
                </b-col>
                <b-col md="12" class="mt-3">
                  <a href="javascript:void(0)" @click="onExample('exPopup')">
                    <strong class="font-weight-bold text-primary">
                      {{ $t('global.exampleAsset') }}
                    </strong>
                  </a>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="12" md="6">
              <b-row>
                <b-col md="12">
                  <div class="mc-input-info">
                    <b-form-group
                      :label="$t('setting.list.managementAsset.banner.ctaLink')"
                      id="fleet_brand_type_label"
                      label-for="fleet_brand_type"
                    >
                      <input
                        class="form-control"
                        type="text"
                        id="ctaLink"
                        :placeholder="$t('setting.list.managementAsset.banner.exCtaLink')"
                        v-model="ctaLink"
                      />
                    </b-form-group>
                  </div>
                </b-col>
                <b-col md="12" class="mt-3">
                  <b-button @click="changeCtaLink()" variant="primary">
                    <i class="mc-fa icon-fill_checkmark"></i>
                    {{ $t('global.apply') }}
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-collapse>
    </div>

    <div class="mc-form mb-3">
      <div class="form-check-right form-switch">
        <input
          class="form-check-input"
          type="checkbox"
          v-b-toggle.accordion-sidebar
          v-model="switchSidebar"
          v-on:change="onSwitchSidebar"
        />
      </div>
      <span class="card-title p-2">{{ $t('setting.list.managementAsset.banner.sidebar') }}</span>
      <b-collapse
        id="accordion-sidebar"
        accordion="accordionSidebar"
        role="tabpanel"
        v-model="visibleSidebar"
      >
        <b-card>
          <b-row>
            <b-col sm="12" md="6">
              <h5 class="font-size-14 teal-200 mb-1">
                {{ $t('setting.list.managementAsset.banner.sidebarMax') }}
              </h5>
              <b-row>
                <b-col md="3">
                  <div
                    class="d-flex justify-content-center mb-2 img-pointer img-pointer"
                    @click="previewImage('exSidebarMax')"
                  >
                    <img
                      :src="imgSidebarMax"
                      alt
                      class="avatar-lg rounded-circle img-thumbnail"
                      style="object-fit: cover"
                    />
                  </div>
                </b-col>
                <b-col md="12">
                  <h5 class="font-size-12 teal-400 mb-1">
                    {{ nameSidebarMax }}
                  </h5>
                </b-col>
                <b-col md="12">
                  <div class="mc-input-info">
                    <b-form-group
                      id="fleet_brand_type_label"
                      :label="$t('global.uploadImage')"
                      label-for="fleet_brand_type"
                    >
                      <input
                        class="form-control inputf-ile"
                        type="file"
                        ref="file"
                        id="bannerSidebarMax"
                        accept="image/*"
                        v-on:change="handleFileSelected"
                      />
                    </b-form-group>
                  </div>
                </b-col>
                <b-col md="12" class="mt-3">
                  <a href="javascript:void(0)" @click="onExample('exSidebarMax')">
                    <strong class="font-weight-bold text-primary">
                      {{ $t('global.exampleAsset') }}
                    </strong>
                  </a>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="12" md="6">
              <h5 class="font-size-14 teal-200 mb-1">
                {{ $t('setting.list.managementAsset.banner.sidebarMin') }}
              </h5>
              <b-row>
                <b-col md="3">
                  <div
                    class="d-flex justify-content-center mb-2 img-pointer"
                    @click="previewImage('exSidebarMin')"
                  >
                    <img
                      :src="imgSidebarMin"
                      alt
                      class="avatar-lg rounded-circle img-thumbnail"
                      style="object-fit: cover"
                    />
                  </div>
                </b-col>
                <b-col md="12">
                  <h5 class="font-size-12 teal-400 mb-1">
                    {{ nameSidebarMin }}
                  </h5>
                </b-col>
                <b-col md="12">
                  <div class="mc-input-info">
                    <b-form-group
                      id="fleet_brand_type_label"
                      :label="$t('global.uploadImage')"
                      label-for="fleet_brand_type"
                    >
                      <input
                        class="form-control inputf-ile"
                        type="file"
                        ref="file"
                        id="bannerSidebarMin"
                        accept="image/*"
                        v-on:change="handleFileSelected"
                      />
                    </b-form-group>
                  </div>
                </b-col>
                <b-col md="12" class="mt-3">
                  <a href="javascript:void(0)" @click="onExample('exSidebarMin')">
                    <strong class="font-weight-bold text-primary">
                      {{ $t('global.exampleAsset') }}
                    </strong>
                  </a>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-collapse>
    </div>

    <div class="mc-form">
      <h4 class="card-title">{{ $t('setting.list.managementAsset.banner.homepage') }}</h4>
      <b-card>
        <b-row>
          <b-col sm="12" md="12">
            <b-row>
              <b-col md="3">
                <div
                  class="d-flex justify-content-right mb-2 img-pointer"
                  @click="previewImage('exHomepage')"
                >
                  <img
                    :src="imgHomepage"
                    alt
                    class="avatar-lg rounded-circle img-thumbnail"
                    style="object-fit: cover"
                  />
                </div>
              </b-col>
              <b-col md="12">
                <h5 class="font-size-12 teal-400 mb-1">
                  {{ nameHomepage }}
                </h5>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" md="6">
            <b-row>
              <b-col md="12">
                <div class="mc-input-info">
                  <b-form-group
                    id="fleet_brand_type_label"
                    :label="$t('global.uploadImage')"
                    label-for="fleet_brand_type"
                  >
                    <input
                      class="form-control inputf-ile"
                      type="file"
                      ref="file"
                      id="bannerHomepage"
                      accept="image/*"
                      v-on:change="handleFileSelected"
                    />
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="12" class="mt-3">
                <a href="javascript:void(0)" @click="onExample('exHomepage')">
                  <strong class="font-weight-bold text-primary">
                    {{ $t('global.exampleAsset') }}
                  </strong>
                </a>
              </b-col></b-row
            >
          </b-col>
        </b-row>
      </b-card>
    </div>

    <div class="mc-form mb-3">
      <div class="form-check-right form-switch">
        <input
          class="form-check-input"
          type="checkbox"
          v-b-toggle.accordion-email
          v-model="switchEmail"
          v-on:change="onSwitchEmail"
        />
      </div>
      <span class="card-title p-2">{{ $t('setting.list.managementAsset.banner.email') }}</span>
      <b-collapse
        id="accordion-email"
        accordion="accordionEmail"
        role="tabpanel"
        v-model="visibleEmail"
      >
        <b-card>
          <b-row>
            <b-col sm="12" md="6">
              <b-row>
                <b-col md="3">
                  <div
                    class="d-flex justify-content-center mb-2 img-pointer"
                    @click="previewImage('exEmail')"
                  >
                    <img
                      :src="imgEmail"
                      alt
                      class="avatar-lg rounded-circle img-thumbnail"
                      style="object-fit: cover"
                    />
                  </div>
                </b-col>
                <b-col md="12">
                  <h5 class="font-size-12 teal-400 mb-1">
                    {{ nameEmail }}
                  </h5>
                </b-col>
                <b-col md="12">
                  <div class="mc-input-info">
                    <b-form-group
                      id="fleet_brand_type_label"
                      :label="$t('global.uploadImage')"
                      label-for="fleet_brand_type"
                    >
                      <input
                        class="form-control inputf-ile"
                        type="file"
                        ref="file"
                        id="bannerEmail"
                        accept="image/*"
                        v-on:change="handleFileSelected"
                      />
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="12" class="mt-3">
              <a href="javascript:void(0)" @click="onExample('exEmail')">
                <strong class="font-weight-bold text-primary">
                  {{ $t('global.exampleAsset') }}
                </strong>
              </a>
            </b-col>
          </b-row>
        </b-card>
      </b-collapse>
    </div>

    <b-modal
      id="modalExample"
      size="xl"
      centered
      hide-header
      hide-footer
      modal-class="mc-modal-asset"
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="mc-modal-asset__wrapper">
        <i class="mc-fa icon-outline_close" @click="closeExample()"></i>
        <b-carousel id="carousel-1" controls no-animation>
          <b-carousel-slide
            v-for="item in carouselItems"
            :key="item.id"
            :img-src="item.image"
            :caption="item.caption"
            :interval="0"
          ></b-carousel-slide>
        </b-carousel>
      </div>
    </b-modal>

    <b-modal
      id="modalPreviewImage"
      size="xl"
      centered
      hide-header
      hide-footer
      modal-class="mc-modal-asset"
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="mc-modal-preview-banner__wrapper">
        <i class="mc-fa icon-outline_close" @click="closeExample()"></i>
        <img :src="imgPreview" alt="image preview" />
      </div>
    </b-modal>
  </Layout>
</template>
